import { defineComponent } from 'vue';
import { QList, QItem, QItemSection, QItemLabel } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const SELECT_LIST_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'select-list-dsgn',
    mixins: [BaseComponentMixin],
    components: { QList, QItem, QItemSection, QItemLabel },
    data() {
        return {
            source: null,
        };
    },
    mounted() {
        this.Refresh();
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, SELECT_LIST_CLICK_CODE_BEHIND);
        },
        async Refresh() {
            if (this.controlData.SourceType === 'URL') {
                try {
                    this.source = await utils.api.get(this.controlData.SourceURL, true);
                }
                catch (e) {
                    this.source = null;
                }
            }
            else if (this.controlData.SourceType == 'Raw') {
                if (typeof this.controlData.Source === 'object' && Array.isArray(this.controlData.Source))
                    this.source = this.controlData.Source;
            }
        },
    },
    props: {
    },
    render() {
        if (!this.controlData?.FieldMappings)
            return null;

        const fields = this.controlData.FieldMappings;
        const items = [];
        let source = this.source;
        const usePlaceholder = !source || !Array.isArray(source) || source.length === 0;

        if (usePlaceholder) {
            const obj = {};
            obj[fields.Title] = 'Title';
            obj[fields.Description] = 'Description';
            source = [obj];
        }

        for (let i = 0; i < source.length; i++) {
            const item = source[i];
            const isSelected = usePlaceholder && i === 0;
            const itemStyle = isSelected
                ? { background: '#cfcfcf', border: '1px solid #b6b6b6', borderRadius: '8px', margin: '2px' }
                : { background: 'transparent', border: '1px solid transparent', borderRadius: '8px', margin: '2px' };

            items.push(
                <QItem
                    key={i}
                    clickable
                    active={isSelected}
                    class="q-mx-xs q-my-sm q-px-sm q-py-xs"
                    style={itemStyle}>
                    <QItemSection>
                        <QItemLabel class="text-weight-medium text-dark q-mt-sm">{item[fields.Title]}</QItemLabel>
                        <QItemLabel caption class="text-grey-7 q-mb-sm">{item[fields.Description]}</QItemLabel>
                    </QItemSection>
                </QItem>
            );
        }

        const style = {
            overflow: 'auto',
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(this.controlData.StyleHints, this),
        };

        return (
            <div
                class={{
                    'c-SelectList': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    'designer-container': true,
                    selected: this.selected$,
                }}
                style={style}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QList dense class="q-py-xs" style={{ background: '#ececec' }}>
                    {items}
                </QList>
            </div>
        );
    },
});
